export const CSV_EXPORT_CONSTANTS = {
  MAX_ROWS: 1000000,
  ROWS_PER_PAGE: 200000,
  get TOTAL_PAGES() {
    return Math.ceil(this.MAX_ROWS / this.ROWS_PER_PAGE);
  },
};
